import { FC } from 'react';
import { Modal } from 'components';
import SectionStyled, { ContentStyled } from './styles';

type ApproveRYProps = {
  visibleApproveRKY?: boolean;
  onOk?: () => void;
  onCancel?: () => void;
  title?: string;
};

const ApproveRKY: FC<ApproveRYProps> = ({
  visibleApproveRKY = false,
  onOk = () => null,
  onCancel = () => null,
  title = '',
}) => {
  const okButton = { text: '承認', onClick: () => onOk() };
  const cancelButton = { text: 'キャンセル', onClick: () => onCancel() };

  return (
    <SectionStyled>
      <Modal
        title={title}
        visible={visibleApproveRKY}
        width={640}
        okButton={okButton}
        cancelButton={cancelButton}
      >
        <ContentStyled>この操作は元に戻せません</ContentStyled>
      </Modal>
    </SectionStyled>
  );
};

export default ApproveRKY;
